import React from 'react';
import './LevelTransition.css';

function LevelTransition({ transitionState, levelNumber }) {
  return (
    <div className={`level-transition-overlay ${transitionState}`}>
      <div className="level-text">
        Level {levelNumber}
      </div>
    </div>
  );
}

export default LevelTransition;